import { render, staticRenderFns } from "./jump-icon.svg.vue?vue&type=template&id=0dfeb094&"
import script from "./jump-icon.svg.vue?vue&type=script&lang=js&"
export * from "./jump-icon.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports